import { BlockView, PageRuntime } from "../blocks/blocks.tsx";
import { useSession } from "../lib/session.tsx";
import type { BlockDef } from "../lib/types.ts";

/** The automatic screen of a collection: every record, the one clicked, and a form. */
export function DataView({ name }: { name: string }) {
  const s = useSession();
  const c = s.collections.find((x) => x.name === name);
  if (!c) return <p className="hint">{s.collections.length ? `A coleção "${name}" não existe.` : "Carregando…"}</p>;
  const read = c.access?.read ?? true;
  const create = c.access?.create ?? true;
  const blocks: BlockDef[] = [
    ...(read
      ? ([
          { id: "b_auto_tbl", type: "table", width: "full", collection: name, columns: c.fields.slice(0, 6).map((f) => f.name), pageSize: 20 },
          { id: "b_auto_det", type: "details", width: "half", collection: name, title: "Registro", source: "b_auto_tbl" },
        ] as BlockDef[])
      : []),
    ...(create ? ([{ id: "b_auto_frm", type: "form", width: read ? "half" : "full", collection: name, title: "Novo registro" }] as BlockDef[]) : []),
  ];
  return (
    <PageRuntime collections={s.collections} workflows={s.workflows}>
      <div className="topbar">
        <h1>{c.label}</h1>
        <span className="muted">
          <code>{c.name}</code> · {c.fields.length} campos
        </span>
      </div>
      {!c.fields.length ? (
        <p className="hint">Esta coleção ainda não tem campos.</p>
      ) : (
        <div className="grid">
          {blocks.map((b) => (
            <div key={b.id} className={`blk card ${b.width}`}>
              <BlockView block={b} />
            </div>
          ))}
        </div>
      )}
    </PageRuntime>
  );
}
